import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BidValidators {
  constructor() {}

  ValidateYears() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value > 4 || control.value < 1) {
        return { years: true };
      }
      return null;
    };
  }

  CheapYears() {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (
        control.get('amount').value < 10 &&
        control.get('years').value === 4
      ) {
        return { cheapYears: true };
      }
      return null;
    };
  }

  MinimumTotalAmount(maxBidTotalAmount) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value <= maxBidTotalAmount) {
        return { currentTotalAmount: true };
      }
      return null;
    };
  }
}
